// frontend/src/components/shared.js
// Shared UI primitives and constants used across admin tabs.

export const ACCENT_OPTIONS = [
  { key: "amber", label: "Amber" },
  { key: "teal", label: "Teal" },
  { key: "orange", label: "Burnt Orange" },
  { key: "terracotta", label: "Terracotta" },
  { key: "sky", label: "Sky" },
];

// Color palette options for group headings (ProductsTab)
export const PALETTE_OPTIONS = [
  { key: "primary", label: "Amber" },
  { key: "secondary", label: "Teal" },
  { key: "accentOrange", label: "Burnt Orange" },
  { key: "accentTerracotta", label: "Terracotta" },
  { key: "accentSky", label: "Sky" },
  { key: "leadline", label: "Leadline (Black)" },
];

// Extended palette options including backgrounds (LayoutTab)
export const PALETTE_OPTIONS_ALL = [
  ...PALETTE_OPTIONS,
  { key: "backgroundClear", label: "Clear Glass (Cream)" },
  { key: "backgroundFrosted", label: "Frosted" },
  { key: "textDark", label: "Text Dark" },
];

export const Field = ({ label, children }) => (
  <div className="block">
    <span className="block text-xs mb-1 text-[#3A3530]">{label}</span>
    {children}
  </div>
);

export const TextInput = ({ value, onChange, placeholder }) => (
  <input
    value={value || ""}
    onChange={(e) => onChange(e.target.value)}
    placeholder={placeholder}
    className="w-full leadline-border-thin px-2 py-1 bg-white text-sm"
  />
);

export const SectionCard = ({ title, accentColor, className = "", children }) => (
  <div className={`leadline-border overflow-hidden bg-[#F5EDE0] ${className}`}>
    <div
      className="px-4 py-2 text-sm font-medium text-white"
      style={{ backgroundColor: accentColor || "#3A3530" }}
    >
      {title}
    </div>
    <div className="p-4 space-y-3">{children}</div>
  </div>
);
